import React, { useState } from "react";
import { rootContext, mainOfGame, isFl84 } from "@/context/rootContext";

function GlobalContextBox(props) {

  const initEnterRegion = () => {
    if (!mainOfGame) { return null; }
    switch (true) {
      case isFl84: return "farlight84";
      default: return null;
    }
  };

  const enterRegionBase = initEnterRegion();

  const [isLogin, setIsLogin] = useState(false);
  const [token, setToken] = useState("");
  const [refreshToken, setRefreshToken] = useState("");
  const [activeGame, setActiveGame] = useState(0);
  const [gameTab, setGameTab] = useState([]);
  const [gameList, setGameList] = useState([]);
  const [dialogIndex, setDialogIndex] = useState(0);
  const [nextDialog, setNextDialog] = useState(0);
  const [tipContent, setTipContent] = useState("");
  const [creatorData, setCreatorData] = useState(null);
  const [headFixed, setHeadFixed] = useState(false);
  const [verify, setVerify] = useState(false);
  const [protocols, setProtocols] = useState([]);
  const [scale, setScale] = useState(1);
  const [guideTask, setGuideTask] = useState([]);
  const [gamePlatform, setGamePlatform] = useState(null);
  const [ableMedia, setAbleMedia] = useState([]);
  const [enterRegion, setEnterRegion] = useState(enterRegionBase);
  const [loginStatus, setLogionStatus] = useState([]);
  const [ableLanguage, setAbleLanguage] = useState([]);
  const [ablePos, setAblePos] = useState([]);
  const [refreshVideo, setRefreshVideo] = useState(false);
  const [refreshVideoTime, setRefreshVideoTime] = useState(0);
  const [activeContentList, setActiveContentList] = useState({});
  const [readTapIndex, setReadTapIndex] = useState([1, 1, 1]);

  const globalContext = {
    isLogin, setIsLogin,
    token, setToken,
    gameTab, setGameTab,
    gameList, setGameList,
    activeGame, setActiveGame,
    dialogIndex, setDialogIndex,
    creatorData, setCreatorData,
    tipContent, setTipContent,
    headFixed, setHeadFixed,
    verify, setVerify,
    protocols, setProtocols,
    scale, setScale,
    nextDialog, setNextDialog,
    guideTask, setGuideTask,
    gamePlatform, setGamePlatform,
    refreshToken, setRefreshToken,
    ableMedia, setAbleMedia,
    enterRegion, setEnterRegion,
    loginStatus, setLogionStatus,
    ableLanguage, setAbleLanguage,
    ablePos, setAblePos,
    refreshVideo, setRefreshVideo,
    refreshVideoTime, setRefreshVideoTime,
    activeContentList, setActiveContentList,
    readTapIndex, setReadTapIndex
  };

  const context = Object.assign(globalContext, props.locationContext || {});

  return (
    <rootContext.Provider value={context}>
      {props.children}
    </rootContext.Provider>
  );
}


export default GlobalContextBox;
